import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errorMessage } from "@/lib/api";

export const NameDialog = ({ open, initialName, onClose, onSubmit }) => {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setName(initialName);
  }, [open, initialName]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      await onSubmit(name.trim());
      onClose();
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="project-name-dialog">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Rename project</DialogTitle>
            <DialogDescription>Give it a name your team will recognise.</DialogDescription>
          </DialogHeader>
          <div className="my-5 space-y-2">
            <Label htmlFor="project-name">Project name</Label>
            <Input id="project-name" value={name} onChange={(e) => setName(e.target.value)} maxLength={80} autoFocus data-testid="project-name-dialog-input" />
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={onClose} data-testid="project-name-dialog-cancel">Cancel</Button>
            <Button type="submit" disabled={busy || !name.trim()} data-testid="project-name-dialog-submit">
              {busy && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}Save
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
